export default {
    name:'',
    tel:'',
    point:'',
    credit:'', // ยอดเงินเซ็น เป็นเงินเซ็นเริ่มต้นบัญชี
    moreCredit:0, // ยอดเงินเซ็น ใน logic ใหม่ 
    shopId:'', // ดูว่าสมัครจากสาขาไหน
    landlordId:'',
    timestamp:new Date(),
    bought:[],
    config:[],
    uid:'', // เชื่อมต่อกับไลน์ OA
    providerId:'', // แบบที่เชื่อมต่อกันหลายสาขา
    imageId:'',
};
